<template>
    <div class="new-msg-box" v-if="isMsgAlert && newsList.title!=''">
        <div class="msg-center">
                <span class="new-msg-text fl">最新消息：</span><i class="new-msg-triangle fl"></i>
                <span class="new-msg-content basefont curp fl" @click="routerlinkid('/news',newsList.id,6)">{{ newsList.title }}</span> 
                <span class="el-icon-close msg-close-btn fl" @click="onClickColseMsg"></span>
        </div>
    </div> 
  </template>
  <script>
  import { mapState, mapMutations, mapGetters } from "vuex";
  export default {
    name: 'message-alert-pop',
    computed: {
		...mapState({
		    isMsgAlert: (state) => state.isMsgAlert,
		}),
		...mapGetters(['isMsgAlert'])
		},
    data () {
      return {
        newsList:{title:''},
      }
    },
    props:{
        userdata:{type:Object,default:{}},
    },
    created(){
    },
    mounted() { 
    //    this.getUserMessage();
    },
    methods: {
    ...mapMutations({
            set_collapse: "SET_COLLAPSE",
            set_msgAlert: "SET_MSGAlERT",
        }),
    onClickColseMsg() {
            // console.log('关闭消息',this.isMsgAlert);
            this.set_msgAlert(!this.isMsgAlert)
        },
    //动态消息展示
    getUserMessage() {
        var that = this;
        this.$axios.get(this.$api.cyl.userMessage.latest(), {
            headers: {
                AuthToken: this.userdata.token
            }
        }).then(function(res) {
            // console.log('动态消息展示',res); 
            if (res.data.success) {
                that.newsList = res.data.data||{title:''};
            }
        })
    },
    }
  }
  </script>
  <style>
  .new-msg-box{
    z-index: 2;
    position: fixed;
    width: 100%;
    bottom: 10%;
}
.msg-center{
    width: 31%;
    min-width: 580px;
    margin: 0 auto;
    overflow: hidden;
} 
.new-msg-text{
    display: inline-block;
    background: orangered;
    height: 30px;
    line-height: 30px;
    padding:10px 20px;
    color: #fff;
    font-weight: bold;
    letter-spacing: 2px;
    border-radius: 5px 0 0 5px;
}
.new-msg-triangle{
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 25px solid #ffece2; 
    border-right: 20px solid #ffece2;
    border-left: 30px solid orangered;
    border-bottom: 25px solid #ffece2;
    position: relative;
    top: 0;
    }
.new-msg-content{
    display: inline-block;
    height:50px;
    line-height: 50px;
    width: 60%;
    background: #ffece2; 
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.msg-center .msg-close-btn{
    display: inline-block;
    width: 50px;
    height: 30px;
    line-height: 30px;
    padding: 10px 0;
    text-align: center;
    background: #ffece2;
    border-radius: 0 5px 5px 0;
    cursor: pointer;
    font-weight: bold;
}
.msg-center .msg-close-btn:hover{
    color: #f39800 ;
}
  </style>